import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { SELECTABLE_BORDER_WIDTH } from '../Selectable';

export const LARGE_SELECTABLES_ITEM_WIDTH = 104;
export const LARGE_SELECTABLES_ITEM_HEIGHT = 82;
export const LARGE_SELECTABLES_ITEM_CONTENT_WIDTH = LARGE_SELECTABLES_ITEM_WIDTH - SELECTABLE_BORDER_WIDTH * 2;
export const LARGE_SELECTABLES_ITEM_CONTENT_HEIGHT = LARGE_SELECTABLES_ITEM_HEIGHT - SELECTABLE_BORDER_WIDTH * 2;

const LargeSelectablesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  
  /* Cancel out margin-bottom of last row of items */
  margin-bottom: -${globalTheme.spacing.xs};
`;

const LargeSelectablesItem = styled.div`
  &:not(:nth-child(3n)) {
    margin-right: ${globalTheme.spacing.xs};
  }
  margin-bottom: ${globalTheme.spacing.xs};
`;

export interface LargeSelectablesCompoundComponents {
  Item: typeof LargeSelectablesItem,
}

export const LargeSelectables: FC & LargeSelectablesCompoundComponents = ({ children }) => (
  <LargeSelectablesContainer>{children}</LargeSelectablesContainer>
);

LargeSelectables.Item = LargeSelectablesItem;
